export default {"src":"/_next/static/media/evro.9781e6e9.gif","height":524,"width":655,"blurWidth":0,"blurHeight":0};